import firebase from 'firebase';
import 'firebase/firestore';


 // Your web app's Firebase configuration
 var firebaseConfig = {
    apiKey: "AIzaSyAbstPHnKFShttDWmCGr58NI19Ba7y1I4A",
    authDomain: "vue-todo-or-nottodo.firebaseapp.com",
    databaseURL: "https://vue-todo-or-nottodo.firebaseio.com",
    projectId: "vue-todo-or-nottodo",
    storageBucket: "vue-todo-or-nottodo.appspot.com",
    messagingSenderId: "927992285735",
    appId: "1:927992285735:web:32f4174dffb8d1fdd75c02"
  };
  // Initialize Firebase
 export const db = firebase.initializeApp(firebaseConfig).firestore();